import { render, staticRenderFns } from "./AdminSetup.vue?vue&type=template&id=65091cb0&scoped=true"
import script from "./AdminSetup.vue?vue&type=script&lang=js"
export * from "./AdminSetup.vue?vue&type=script&lang=js"
import style0 from "./AdminSetup.vue?vue&type=style&index=0&id=65091cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65091cb0",
  null
  
)

export default component.exports